import React from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';

import Order from '../Order';
import Oauth from '../OAuth';
import Login from '../Login';
import Verify from '../Verify';
import Orders from '../Orders';
import Account from '../Account';
import NoMatch from '../NoMatch';
import Register from '../Register';
import PasswordReset from '../Reset';
import PrivateRoute from './AuthRoute';
import OrderCreate from '../OrderCreate';
import Connections from '../Connections';
import VerifyPassword from '../VerifyPassword';

import { AuthContain } from './AppStyled';

import config from 'config';

const Form1OrderCreate = (props) => <OrderCreate {...props} orderType="FORM1" />;
const StrataOrderCreate = (props) => <OrderCreate {...props} orderType='STRATA_SEARCH' />;

const AppRouter = ({ beta, isAuth, appBar, notices }) => (
  <BrowserRouter basename={config.site.baseName}>
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/verify" component={Verify} />
      <Route exact path="/password-verify" component={VerifyPassword} />
      <Route exact path="/password-reset" component={PasswordReset} />
      <PrivateRoute exact path="/oauth/auth" isAuth={isAuth} component={Oauth} />
      <AuthContain>
        {appBar}
        <Switch>
          <PrivateRoute
            exact
            path="/"
            isAuth={isAuth}
            component={(props) => <Redirect to={{ pathname: '/orders', state: {}, search: props.location.search }} />}
          />
          <PrivateRoute exact path="/account" isAuth={isAuth} component={Account} />
          <PrivateRoute exact path="/orders" isAuth={isAuth} component={Orders} notices={notices} />
          <PrivateRoute exact path="/connections" isAuth={isAuth} component={Connections} />
          <PrivateRoute
            exact
            path="/orders/council"
            isAuth={isAuth}
            component={OrderCreate}
          />
          <PrivateRoute
            exact
            path="/orders/form1"
            isAuth={isAuth}
            component={Form1OrderCreate}
          />
          <PrivateRoute
            exact
            path="/orders/strata"
            isAuth={isAuth}
            component={StrataOrderCreate}
          />
          <PrivateRoute
            exact
            path="/orders/:orderId"
            isAuth={isAuth}
            component={Order}
          />
          <Route component={NoMatch} />
        </Switch>
      </AuthContain>
    </Switch>
  </BrowserRouter>
);

export default AppRouter;
